export interface SignResponse {
  action: string;
  signature: string;
  error?: string;
}

export const signPdfWithSerpro = (base64Pdf: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const endpoints = [
      'wss://127.0.0.1:65056/',
      'ws://127.0.0.1:65056/',
      'wss://127.0.0.1:64056/',
      'ws://127.0.0.1:64056/'
    ];
    let currentIndex = 0;

    const tryConnect = () => {
      if (currentIndex >= endpoints.length) {
        reject(new Error('Não foi possível conectar ao Assinador SERPRO. Verifique se o aplicativo está instalado, aberto e rodando no seu computador.'));
        return;
      }

      const url = endpoints[currentIndex];
      console.log(`Tentando conectar ao Assinador SERPRO em: ${url}`);
      const ws = new WebSocket(url);

      ws.onopen = () => {
        console.log(`Conectado com sucesso ao Assinador SERPRO em ${url}`);
        const payload = {
          command: 'sign',
          type: 'pdf',
          file: base64Pdf
        };
        ws.send(JSON.stringify(payload));
      };

      ws.onmessage = (event) => {
        try {
          const response = JSON.parse(event.data);
          if (response.error) {
            reject(new Error(response.error));
            ws.close();
            return;
          }

          if (response.action === 'sign' && response.signature) {
            resolve(response.signature); // Base64 of the signed PDF
            ws.close();
          } else if (response.action === 'error') {
            reject(new Error(response.error || 'Erro desconhecido ao assinar pelo Serpro'));
            ws.close();
          }
        } catch (e) {
          reject(new Error('Erro ao processar resposta do Assinador SERPRO'));
          ws.close();
        }
      };

      ws.onerror = (err) => {
        console.warn(`Falha na conexão SERPRO (${url}):`, err);
        // Não rejeitar ainda. Tentar o próximo endereço ao fechar
      };

      ws.onclose = (event) => {
        console.log(`Conexão fechada (${url}).`);
        // Só tenta o próximo se falhou a conexão (código 1006)
        if (event.code !== 1000 && event.code !== 1005) {
          currentIndex++;
          tryConnect();
        }
      };
    };

    tryConnect();
  });
};
